<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Revenue Report
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addIbasUser()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title class="mt-5">
            <v-row>
              <v-col cols="8" class="mt-0 pt-0">
                <v-select
                  :items="loadTypes"
                  label="Wallet Type"
                  v-model="form.loadType"
                ></v-select>
              </v-col>

              <v-col cols="4" class="mt-0 pt-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.date"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.date"
                    :allowed-dates="
                      (date) =>
                        date <=
                        new Date(
                          Date.now() - new Date().getTimezoneOffset() * 64000
                        )
                          .toISOString()
                          .substr(0, 10)
                    "
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" lg="3" md="6">
                <card-widget
                  icon="mdi-currency-usd"
                  label="Wallet"
                  iconColor="#fffffff"
                  cardColor="primary"
                  :isDark="true"
                  :value="loadingWallet ? 0 : 0"
                ></card-widget>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            disable-pagination
            :hide-default-footer="true"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import CardWidget from "../../components/CardWidget.vue";
export default {
  mixins: [ShareableMethods],
  name: "SPRevenueReport",
  components: { CardWidget },
  data() {
    return {
      dateMenu: false,
      loadTypes: ["Load Wallet", "Install Wallet"],
      form: {
        loadType: "Load Wallet",
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 64000)
          .toISOString()
          .substr(0, 10),
      },
      search: "",
      loadingWallet: true,
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Distributor",
            value: "dealerName",
          },

          {
            text: "Beginning Balance",
            value: "beginningBalance",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },

          {
            text: "Ending Balance",
            value: "endingBalance",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },
          {
            text: "Daily Wallet Top-up",
            value: "dailyTopup",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },

          {
            text: "Wallet Balance Difference",
            value: "balance",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },

          {
            text: "Daily Wallet Deduction",
            value: "deduction",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },

          {
            text: "Daily Wallet Deduction (from per record of Load)",
            value: "deduction",
            sortable: false,
            align: "center",
            formatter: (x) => (x ? this.setToLocaleString(x) : 0.0),
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$drs
        .get(
          `/broker/drs/revenue-report?type=${this.form.loadType}&date=${this.form.date}`
        )
        .then((response) => {
          const newArr = response.data.data;
          console.log(newArr);
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    // changeType() {
    //   if (this.form.loadType === "Load Wallet") {
    //     console.log("load");
    //   } else {
    //     console.log("install");
    //   }
    // },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    "form.loadType"() {
      this.getList();
    },

    "form.date"() {
      this.getList();
    },
  },

  computed: {},
};
</script>
